// @flow
import React from 'react';

import { t } from 'Src/i18n';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { formatDate } from 'Utils/date/dateUtils';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { DateSummary } from 'Components/widgets/package/price/DateSummary';
import { AttendeesSummary } from 'Components/widgets/package/price/AttendeesSummary';
import { TransportSummary } from 'Components/widgets/package/price/TransportSummary';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
import { getDepartureDate } from 'Components/widgets/alternative-proposals/AlternativeProposalsUtils';

type Props = {
  adultsNumber: number,
  arrivalDate: string,
  departureCity: string,
  duration: number,
  i18n: CMSContent,
  kidsNumber: number,
};

export const AlternativeResortCriteria = (props: Props) => {
  const { adultsNumber, arrivalDate, departureCity, duration, kidsNumber } = props;

  const getFormattedDate = formatDate('D MMMM YYYY');
  const departureDate = getDepartureDate({
    date: arrivalDate,
    duration,
    format: API_DATE_FORMAT,
    unit: 'days',
  });

  return (
    <div
      data-testid="AlternativeResortCriteria"
      className="AlternativeResort-criteria flex flex-col mt-3 mb-8 md:mt-0 md:mb-0 md:mr-4 md:rtl:mr-4 md:rtl:ml-0"
    >
      <Capsule
        additionalStyle={{
          content: { padding: '20px', fontSize: '14px' },
        }}
      >
        <div>
          <DateSummary
            template={t('booking.counterProposalPopIn.fromTo')}
            values={{
              arrivalDate: getFormattedDate(arrivalDate, 'YYYYMMDD') || '',
              departureDate: getFormattedDate(departureDate, 'YYYYMMDD') || '',
            }}
          />
        </div>
        <div className="mt-4">
          <AttendeesSummary adults={adultsNumber} kids={kidsNumber} />
        </div>
        <div className="mt-4">
          <TransportSummary
            departure={departureCity !== 'NO' ? departureCity : null}
            transportIcon={ICONS.TRANSPORT}
          />
        </div>
        <div className="flex mt-4">
          <Icon
            className="AlternativeResortCriteria-icon flex-shrink"
            color={COLORS.ORANGE}
            name={ICONS.WARNING}
            width="2rem"
            hasRtl
          />
          <div className="AlternativeResortCriteria-textWarning font-bold ml-2 text-orange rtl:ml-2 rtl:mr-0">
            {t('booking.counterProposalPopIn.resortCounterProposalTransportReassurance')}
          </div>
        </div>
      </Capsule>
    </div>
  );
};
